import AbstractDbSelect from '../form/abstract-db-select';

class DbDropdown extends AbstractDbSelect {
    protected selectContainerClass = 'survey-element-container';
    protected validOptionsSelector = 'option:not(.no-selection)';
}

export default function () {
    $(function () {
        new DbDropdown().init();
    });
}

